import React from 'react';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import styles from "./styles.scss";

const CampaignBanner = props => {
  const { height, isMobile } = useViewport();
  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    thumbnail_mobile,
    banner_video,
  } = props.data;

  let className = 'campaign-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;
  let countLengthOf = StringUtil.sliceHtml(description);
  const length = words(countLengthOf).length;

  const renderDescription = () => {
    return (
      <HTMLView
        className={'campaign-banner-description'}
        html={description}
        tagName={'div'}
      />
    );
  };

  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'campaign-banner-image'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
        length={length}
        description={!isMobile && renderDescription()}
        descriptionClass={'campaign-banner-description'}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && <FooterExploreButton sectionName={'campaign'} />}
    </div>
  );
};

export default CampaignBanner;
